/**
 * Created by LIDHCRT on 2/2/2018.
 */
module.exports = ['$scope', 'sessionData', function($scope, sessionData) {
    $scope.selectedgroups = [];
    var groupAccess = sessionData.employerInfo.planAdministratorEntitlements.groupLevelEntitlements;
    $scope.$on("recieving from reports", function(event, message, selectAll) {

        $scope.message = message;
        $scope.selectAllFromReports = selectAll;
    });
    $scope.groupTableObj = {

        order: 'groupNumber',
        reverse: false,
        selectAllRows: $scope.selectAllFromReports === true  ? true: false,
        rowSelectionEnabled: true,

        titles: [
            {
                name: 'Group Number',
                dataKey: 'groupNumber'
            }

        ],
        pagination: {
            itemsPerPage: 12,
            page: 1
        },


        groupAccessArray : []
    };

    if (groupAccess) {
        for (var grp in groupAccess) {
            if (groupAccess.hasOwnProperty(grp)) {
                var group = {};
                var current = groupAccess[grp];
                group.groupNumber = grp;
                group.selected = false;
                //group.spendingAccount = current['Spending Account'] || 'N/A';

                if ((current['Employee Data'] === 'View' || current['Employee Data'] === 'Modify')) {
                    $scope.groupTableObj.groupAccessArray.push(group);
                }
            }
        }

    }


    if($scope.message) {
        for (var indi = 0; indi < $scope.message.length; indi++) {
            for (var index = 0; index < $scope.groupTableObj.groupAccessArray.length; index++) {
                if ($scope.groupTableObj.groupAccessArray[index].groupNumber === $scope.message[indi]) {
                    $scope.groupTableObj.groupAccessArray[index].selected = true;
                    $scope.selectedgroups.push($scope.message[indi]);
                }
            }

        }
    }

    $scope.isChecked = function(product) {


        var idx = $scope.selectedgroups.indexOf(product.groupNumber);
        if (idx > -1) {
            product.selected = false;
            $scope.selectedgroups.splice(idx, 1);
        }

        // Is newly selected
        else {
            product.selected = true;
            $scope.selectedgroups.push(product.groupNumber);
        }


    };

    $scope.$watch("groupTableObj.selectAllRows",function(newValue,oldValue){

        var filter=$scope.groupTableObj.groupAccessArray.filterBy;
        if(oldValue!=newValue && newValue === true){

            $scope.selectedgroups = [];
            for(var index=0; index<$scope.groupTableObj.groupAccessArray.length;index++) {
                var key= $scope.groupTableObj.groupAccessArray[index].groupNumber;
                if(key && ((filter && (key.indexOf(filter)>=0 || filter.trim()==="")) || !filter)){
                    $scope.groupTableObj.groupAccessArray[index].selected=$scope.groupTableObj.selectAllRows;
                    $scope.selectedgroups.push($scope.groupTableObj.groupAccessArray[index].groupNumber);

                }


            }

        }
        else if(newValue === false && oldValue!=newValue && $scope.message && $scope.message.length === $scope.groupTableObj.groupAccessArray.length) {
            $scope.groupTableObj.selectAllRows === true;
            for (var indx = 0; indx < $scope.groupTableObj.groupAccessArray.length; indx++) {
                var key1 = $scope.groupTableObj.groupAccessArray[indx].groupNumber;
                if (key1 && ((filter && (key1.indexOf(filter) >= 0 || filter.trim() === "")) || !filter)) {
                    $scope.groupTableObj.groupAccessArray[indx].selected = $scope.groupTableObj.selectAllRows;
                    var idx = $scope.selectedgroups.indexOf($scope.groupTableObj.groupAccessArray[indx].groupNumber);
                    $scope.selectedgroups.splice(idx, 1);
                }
            }
        }
        else if(newValue === false && oldValue!=newValue) {
            if($scope.selectAllFromReports === undefined){

                for (var indx2 = 0; indx2 < $scope.groupTableObj.groupAccessArray.length; indx2++) {
                    var key3 = $scope.groupTableObj.groupAccessArray[indx2].groupNumber;
                    if (key3 && ((filter && (key3.indexOf(filter) >= 0 || filter.trim() === "")) || !filter)) {
                        $scope.groupTableObj.groupAccessArray[indx2].selected = $scope.groupTableObj.selectAllRows;
                        var idx3 = $scope.selectedgroups.indexOf($scope.groupTableObj.groupAccessArray[indx2].groupNumber);
                        $scope.selectedgroups.splice(idx3, 1);
                    }
                }
            }
            else if( oldValue === $scope.selectAllFromReports){
                for (var indx1 = 0; indx1 < $scope.groupTableObj.groupAccessArray.length; indx1++) {
                    var key2 = $scope.groupTableObj.groupAccessArray[indx1].groupNumber;
                    if (key2 && ((filter && (key2.indexOf(filter) >= 0 || filter.trim() === "")) || !filter)) {
                        $scope.groupTableObj.groupAccessArray[indx1].selected = $scope.groupTableObj.selectAllRows;
                        var idx1 = $scope.selectedgroups.indexOf($scope.groupTableObj.groupAccessArray[indx1].groupNumber);
                        $scope.selectedgroups.splice(idx1, 1);
                    }
                }
            }

        }

    });
    $scope.$on("recieving from reports", function(event, message, selectAll) {

        $scope.message = message;
        $scope.groupTableObj.selectAllRows = selectAll;
    });

    $scope.deselectgroup  = function(event,product) {

        for(var index=0; index<$scope.groupTableObj.groupAccessArray.length;index++){
            if($scope.groupTableObj.groupAccessArray[index].groupNumber === product){
                $scope.groupTableObj.groupAccessArray[index].selected = false;
                var idx = $scope.selectedgroups.indexOf(product);
                $scope.selectedgroups.splice(idx, 1);
            }
        }

       event.stopPropagation();

    };
    $scope.closeSelectionModal = function (){



        $scope.closeModal();

    };

    $scope.sendData = function () {
        $scope.$emit('update_parent_controller', $scope.selectedgroups, $scope.groupTableObj.selectAllRows);
        $scope.closeModal();
    };


}];
